import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Employee Activity Monitor',
		url: '/changes',
		icon: 'user',
	},
];

export default class Changes extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Collections.Changes
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		);
	}
}
